export default "<mc-scope class=\"size-wrap\">\r\n  <router-outlet></router-outlet>\r\n</mc-scope>\r\n"